import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiDateFormatOptions, FiDateTimeFormatOptions, FiTimeFormatOptions } from '@fi-shared/utils';
import { AppTextService } from '@fi-shared/app-text';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiApplicationLanguageType } from '@fi-shared/fi-content-language-shared/fi-application-language-type';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';
import { NotificationRef } from '@fi-app/utilities/notification/notification.service';

@Component({
    selector: 'fi-upgrade-message-notification',
    template: `
        <button mat-icon-button class="fi-upgrade-message-notification-close" (click)="onHideClick()">
          <span class="fa fa-lg fa-times"></span>
        </button>
        @if (upgradeMessageAtLogin || ongoingUpgradeMessage) {
          <div class="login-page-upgrade-message">
            @if (upgradeMessageAtLogin) {
              <div class="text-center upcoming-upgrade-message">
                <span class="Ccm-Label bold fi-upgrade-message-header">{{
                  'app_login.planned_maintenance' | fiAppText
                }}</span>
                <br />
                <span class="Ccm-Label Ccm-Label-Wide">{{ upgradeMessageAtLogin }}</span>
                <span class="Ccm-Label">{{ 'upgrade.logged_out_warning' | fiAppText }}</span>
                <br />
                <span class="Ccm-Label">{{ upgradeEndMessageAtLogin }}</span>
              </div>
            }
            @if (ongoingUpgradeMessage) {
              <div class="text-center">
                <span class="Ccm-Label Ccm-Label-Wide fi-upgrade-message-header">{{
                  'upgrade.new_features_text' | fiAppText
                }}</span>
                <br />
                <span class="Ccm-Label">{{ customerInformation }}</span>
                <br />
                <span class="Ccm-Label Ccm-Label-Wide">{{ ongoingUpgradeMessage }}</span>
              </div>
            }
          </div>
        }
        `,
    styleUrls: ['./upgrade-message-notification.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-upgrade-message-notification' },
    standalone: false,
})
export class UpgradeMessageNotificationComponent implements OnInit {
    upgradeMessageAtLogin: string;
    ongoingUpgradeMessage: string;
    upgradeEndMessageAtLogin: string;
    customerInformation: string;

    constructor(
        private customerDataService: FiCustomerDataService,
        private userDataService: FiUserDataService,
        private appTextService: AppTextService,
        private formatDateService: FiFormatDateService,
        private fiFormatDateService: FiFormatDateService,
        @Inject(NotificationRef) private notiRef,
    ) {}

    ngOnInit() {
        const customerData = this.customerDataService.getCustomerData();
        const upcomingVersion = customerData.UpcomingVersion;

        if (upcomingVersion) {
            const numberOfDaysTillNextUpgrade = customerData.UpcomingVersion.SecondsUntilUpgradeStart / 60 / 60 / 24;
            const updateStart = new Date(customerData.UpcomingVersion.UpgradeOn);
            const updateEnd = new Date(customerData.UpcomingVersion.UpgradeEndTime);

            // https://chainformation.atlassian.net/browse/FI-3545
            const startDateStr = this.fiFormatDateService.formatDate(updateStart, FiDateFormatOptions, {
                showToday: false,
            });
            const startTimeStr = this.fiFormatDateService.formatDate(updateStart, FiTimeFormatOptions);
            const endDateStr = this.fiFormatDateService.formatDate(updateEnd, FiDateFormatOptions, {
                showToday: false,
            });
            const endTimeStr = this.fiFormatDateService.formatDate(updateEnd, FiTimeFormatOptions);

            if (numberOfDaysTillNextUpgrade > 0 && numberOfDaysTillNextUpgrade <= 1) {
                this.upgradeMessageAtLogin = customerData.UpcomingVersion
                    ? this.appTextService.get('upgrade.intranet_will_upgraded', {
                          '{0}': startDateStr,
                          '{1}': startTimeStr,
                      })
                    : '';
                this.upgradeEndMessageAtLogin = customerData.UpcomingVersion
                    ? this.appTextService.get('upgrade.to_be_completed', {
                          '{0}': endDateStr,
                          '{1}': endTimeStr,
                      })
                    : '';
            } else if (numberOfDaysTillNextUpgrade <= 0) {
                this.ongoingUpgradeMessage = this.appTextService.get('upgrade.to_be_completed', {
                    '{0}': endDateStr,
                    '{1}': endTimeStr,
                });

                var timeToEnd =
                    customerData.UpcomingVersion.SecondsUntilUpgradeStart * 1000 +
                    updateEnd.getTime() -
                    updateStart.getTime();
                if (timeToEnd < 0) timeToEnd = 0;

                setTimeout(function () {
                    window.location.reload();
                }, timeToEnd);
            }
            this.customerInformation = upcomingVersion.CustomerInformation;
        }
    }

    onHideClick() {
        this.notiRef.HideNotification();
    }
}
